var _path;

var _excluded = ["title", "titleId"];

function _extends() { _extends = Object.assign ? Object.assign.bind() : function (target) { for (var i = 1; i < arguments.length; i++) { var source = arguments[i]; for (var key in source) { if (Object.prototype.hasOwnProperty.call(source, key)) { target[key] = source[key]; } } } return target; }; return _extends.apply(this, arguments); }

function _objectWithoutProperties(source, excluded) { if (source == null) return {}; var target = _objectWithoutPropertiesLoose(source, excluded); var key, i; if (Object.getOwnPropertySymbols) { var sourceSymbolKeys = Object.getOwnPropertySymbols(source); for (i = 0; i < sourceSymbolKeys.length; i++) { key = sourceSymbolKeys[i]; if (excluded.indexOf(key) >= 0) continue; if (!Object.prototype.propertyIsEnumerable.call(source, key)) continue; target[key] = source[key]; } } return target; }

function _objectWithoutPropertiesLoose(source, excluded) { if (source == null) return {}; var target = {}; var sourceKeys = Object.keys(source); var key, i; for (i = 0; i < sourceKeys.length; i++) { key = sourceKeys[i]; if (excluded.indexOf(key) >= 0) continue; target[key] = source[key]; } return target; }

import * as React from "react";

function SvgShare(_ref, svgRef) {
  var title = _ref.title,
      titleId = _ref.titleId,
      props = _objectWithoutProperties(_ref, _excluded);

  return /*#__PURE__*/React.createElement("svg", _extends({
    width: 17,
    height: 18,
    viewBox: "0 0 17 18",
    fill: "none",
    xmlns: "http://www.w3.org/2000/svg",
    ref: svgRef,
    "aria-labelledby": titleId
  }, props), title ? /*#__PURE__*/React.createElement("title", {
    id: titleId
  }, title) : null, _path || (_path = /*#__PURE__*/React.createElement("path", {
    d: "M12.75 11.9183C12.2117 11.9183 11.73 12.1308 11.3617 12.4637L6.31125 9.52411C6.34667 9.3612 6.375 9.19828 6.375 9.02828C6.375 8.85828 6.34667 8.69536 6.31125 8.53245L11.305 5.6212C11.6875 5.97536 12.1904 6.19495 12.75 6.19495C13.9258 6.19495 14.875 5.24578 14.875 4.06995C14.875 2.89411 13.9258 1.94495 12.75 1.94495C11.5742 1.94495 10.625 2.89411 10.625 4.06995C10.625 4.23995 10.6533 4.40286 10.6888 4.56578L5.695 7.47703C5.3125 7.12286 4.80958 6.90328 4.25 6.90328C3.07417 6.90328 2.125 7.85245 2.125 9.02828C2.125 10.2041 3.07417 11.1533 4.25 11.1533C4.80958 11.1533 5.3125 10.9337 5.695 10.5795L10.7383 13.5262C10.7029 13.6749 10.6817 13.8308 10.6817 13.9866C10.6817 15.127 11.6096 16.0549 12.75 16.0549C13.8904 16.0549 14.8183 15.127 14.8183 13.9866C14.8183 12.8462 13.8904 11.9183 12.75 11.9183Z",
    fill: "#304FC1"
  })));
}

var ForwardRef = /*#__PURE__*/React.forwardRef(SvgShare);
export default __webpack_public_path__ + "static/media/share.d37649035d763c7c765a0cd95482b150.svg";
export { ForwardRef as ReactComponent };